import {Component, OnInit} from '@angular/core';
import {LocalizationService} from '../../control/localization.service';
import {SupportedLanguage} from '../../supported-languages';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';

@Component({
  selector: 'app-language-selector',
  imports: [
    ReactiveFormsModule
  ],
  templateUrl: './language-selector.html',
  styleUrl: './language-selector.scss',
  standalone: true
})
export class LanguageSelector implements OnInit {

  protected formGroup!: FormGroup

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly localizationService: LocalizationService
  ) {
  }

  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
      language: this.localizationService.currentSetLanguage.languageId
    })
    this.formGroup.valueChanges.subscribe(v => this.changeLanguage(v.language))
  }

  protected get supportedLanguages(): SupportedLanguage[] {
    return this.localizationService.supportedLanguages
  }

  protected changeLanguage(languageId: string) {
    this.localizationService.changeLanguage(languageId, () => {
      document.location.reload();
    })
  }
}
